<template>
    
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
   
    <hr>
        <h3 style="text-align: left;">Información General</h3>
        
        <div>
            <div class="py-3 col-md-12 row">
                <div class="col-md-3">
                    <label for="">Razón social como aparece en la constacia fiscal</label><span class="is-invalid">*</span>
                    <input class="form-control" type="text" v-model="form.razon_social"/>
                    <label class="is-invalid">{{ validation.razon_social }}</label>
                </div>
                <div class="col-md-3">
                    <label for="">Telefono</label><span class="is-invalid">*</span>
                    <input class="form-control" type="text" v-model="form.telefono"/>
                    <label class="is-invalid">{{ validation.telefono }}</label>
                    
                </div>
                <div class="col-md-3">
                    <label for="">Email</label><span class="is-invalid">*</span>
                    <input class="form-control" type="text" v-model="form.email"/>
                    <label class="is-invalid">{{ validation.email }}</label>
                    
                </div>
                <div class="col-md-3">
                    <label for="">RFC</label><span class="is-invalid">*</span>
                    <input class="form-control" type="text" v-model="form.rfc"/>
                    <label class="is-invalid">{{ validation.rfc }}</label>
                    
                </div>
            </div>
            <div class="py-3 col-md-12 row">
                <div class="col-md-3">
                    <label for="">Uso de CFDI</label><span class="is-invalid">*</span>
                    <!--<input class="form-control" type="text" v-model="form.cfdi"/>-->
                    <select name="" id="" v-model="form.cfdi" class="form-select">
                        <option  v-for="cfd in cfdi_datos">{{cfd.descripcion}}</option>
                    </select>
                    <label class="is-invalid">{{ validation.cfdi }}</label>
                    <!--<input type="file" @change="onFileChange($event, 'imageFile1')" accept="image/*" class="form-control"/>
                    <br>
                    <div v-if="imagePreview" class="col-md-4 text-center">
                        <img :src="imagePreview" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">
                    </div>-->
                   
                </div>
                <div class="col-md-3">
                    <label for="">Forma de pago</label><span class="is-invalid">*</span>
                    <!--<input class="form-control" type="text" v-model="form.forma_pago"/>-->
                    <select name="" id="" v-model="form.forma_pago" class="form-select">
                        <option  v-for="pago in datosFormaPago">{{pago.descripcion}}</option>
                    </select>
                    <label class="is-invalid">{{ validation.forma_pago }}</label>
                </div>
                <div class="col-md-3">
                    <label for="">Método de pago</label><span class="is-invalid">*</span>
                    <!--<input class="form-control" type="text" v-model="form.metodo_pago"/>-->
                    <select name="" id="" v-model="form.metodo_pago" class="form-select">
                        <option  v-for="pago in datosMetodoPago">{{pago.descripcion}}</option>
                    </select>
                    <label class="is-invalid">{{ validation.metodo_pago }}</label>
                </div> 
                <div class="col-md-3">
                    <label for="">Regimen Fiscal</label><span class="is-invalid">*</span>
                    <select class="form-control" v-model="form.regimen_fiscal">
                        <option value=""></option>
                        <option value="601 General de Ley Personas Morales">601	General de Ley Personas Morales</option>
                        <option value="603 Personas Morales con Fines no Lucrativos">603 Personas Morales con Fines no Lucrativos</option>
                        <option value="605 Sueldos y Salarios e Ingresos Asimilados a Salarios">605 Sueldos y Salarios e Ingresos Asimilados a Salarios</option>
                        <option value="606 Arrendamiento">606 Arrendamiento</option>
                        <option value="607 Régimen de Enajenación o Adquisición de Bienes">607 Régimen de Enajenación o Adquisición de Bienes</option>
                        <option value="608 Demás ingresos">608 Demás ingresos</option>
                        <option value="609 Consolidación">609 Consolidación</option>
                        <option value="610 Residentes en el Extranjero sin Establecimiento Permanente en México">610 Residentes en el Extranjero sin Establecimiento Permanente en México</option>
                        <option value="611 Ingresos por Dividendos (socios y accionistas)">611 Ingresos por Dividendos (socios y accionistas)</option>
                        <option value="612 Personas Físicas con Actividades Empresariales y Profesionales">612 Personas Físicas con Actividades Empresariales y Profesionales</option>
                        <option value="614 Ingresos por intereses">614 Ingresos por intereses</option>
                        <option value="615 Régimen de los ingresos por obtención de premios">615 Régimen de los ingresos por obtención de premios</option>
                        <option value="616 Sin obligaciones fiscales">616 Sin obligaciones fiscales</option>
                        <option value="620 Sociedades Cooperativas de Producción que optan por diferir sus ingreso">620 Sociedades Cooperativas de Producción que optan por diferir sus ingresos</option>
                        <option value="621 Incorporación Fiscal">621 Incorporación Fiscal</option>
                        <option value="622 Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras">622 Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</option>
                        <option value="623 Opcional para Grupos de Sociedades">623 Opcional para Grupos de Sociedades</option>
                        <option value="624 Coordinados">624 Coordinados</option>
                        <option value="625 Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas">625 Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas</option>
                        <option value="626 Régimen Simplificado de Confianza">626 Régimen Simplificado de Confianza</option>
                        <option value="628 Hidrocarburos">628 Hidrocarburos</option>
                        <option value="629 De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales">629 De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales</option>
                        <option value="630 Enajenación de acciones en bolsa de valores">630 Enajenación de acciones en bolsa de valores</option>

                    </select>
                    <label class="is-invalid">{{ validation.regimen_fiscal }}</label>
                </div>
            </div>
            <div class="py-3 col-md-12 row">
                <div class="col-md-3">
                    <label for="">C.P de Domicilio Fiscal</label><span class="is-invalid">*</span>
                    <input class="form-control" type="text" v-model="form.cp_domicilio_fiscal"/>
                    <label class="is-invalid">{{ validation.cp_domicilio_fiscal }}</label>
                    <!--<input type="file" @change="onFileChange($event, 'imageFile1')" accept="image/*" class="form-control"/>
                    <br>
                    <div v-if="imagePreview" class="col-md-4 text-center">
                        <img :src="imagePreview" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">
                    </div>-->
                   
                </div>
                
                <div class="col-md-3">
                    <label for="">Constacia Fiscal  <span class="is-invalid">*</span>  Tamaño máximo 5 MB</label>
                    <input type="file" class="form-control" @change="onFileChangePDF" accept="application/pdf" />
                    <label class="is-invalid">{{ validation.constancia_fiscal_pdf }}</label>
                    <div v-if="fileURL">
                    <h3>Vista previa del archivo:</h3>
                    <iframe :src="fileURL" width="100%" height="200"></iframe>
                    </div>
                    <!--<button v-if="file" @click="uploadFile">Subir Archivo</button>-->
                </div>
                
            </div>
        </div>
        <hr>
        <h3>Domicilio</h3>
        <div>
            <div class="py-3 col-md-12 row">
                <div class="col-md-4">
                    <label for="">Calle</label><span class="is-invalid">*</span>
                    <input class="form-control" type="text" v-model="form.calle"/>
                    <label class="is-invalid">{{ validation.calle }}</label>
                </div>
                <div class="col-md-4">
                    <label for="">Numero exterior</label><span class="is-invalid">*</span>
                    <input class="form-control" type="text" v-model="form.numero_exterior"/>
                    <label class="is-invalid">{{ validation.numero_exterior }}</label>
                </div>
               
                <div class="col-md-4">
                    <label for="">Numero interior</label><span class="is-invalid">*</span>
                    <input class="form-control" type="text" v-model="form.numero_interior"/>
                    <label class="is-invalid">{{ validation.numero_interior }}</label>
                </div>
            </div>
            <div class="py-3 col-md-12 row">
                
                <div class="col-md-4">
                    <label for="">Colonia</label><span class="is-invalid">*</span><br>
                    
                    <input type="text"  class="form-control" v-model="form.colonia"/>
                    <label class="is-invalid">{{ validation.colonia }}</label>
                </div>
                <div class="col-md-4">
                    <label for="">Codigo postal</label><span class="is-invalid">*</span><br>
                    
                    <input type="text"  class="form-control" v-model="form.codigo_postal"/>
                    <label class="is-invalid">{{ validation.codigo_postal }}</label>
                </div>
                <div class="col-md-4">
                    <label for="">Municipio</label><span class="is-invalid">*</span><br>
                    
                    <input type="text"  class="form-control" v-model="form.municipio"/>
                    <label class="is-invalid">{{ validation.municipio }}</label>
                </div>
               <!-- <div class="col-md-3">
                    <label for="">Identificacion * Opcional</label><br>
                    
                    <input type="file" @change="onFileChangeTestigo($event, 'imageFile2')" accept="image/*" class="form-control"/>
                    <br>
                    <div v-if="imagePreview2" class="col-md-4 text-center">
                        <img :src="imagePreview2" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">
                    </div>
                </div>-->
            </div>
            <div class="py-3 col-md-12 row">
                
                <div class="col-md-4">
                    <label for="">Estado</label><span class="is-invalid">*</span><br>
                    
                    <select
                        id="estado"
                        class="form-control"
                        v-model="form.estado"
                    >
                        <option value="">Seleccione un estado</option>

                        <option
                            v-for="item in estados"
                            :key="item.id"
                            :value="item.nombre"
                        >
                            {{ item.nombre }}
                        </option>
                    </select>
                    <label class="is-invalid">{{ validation.estado }}</label>
                </div>
                
               <!-- <div class="col-md-3">
                    <label for="">Identificacion * Opcional</label><br>
                    
                    <input type="file" @change="onFileChangeTestigo($event, 'imageFile2')" accept="image/*" class="form-control"/>
                    <br>
                    <div v-if="imagePreview2" class="col-md-4 text-center">
                        <img :src="imagePreview2" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">
                    </div>
                </div>-->
            </div>
        </div>
       
        <hr>
        <!--<h3>Documentos</h3>
        <div>
            <div class="py-3 col-md-12 row">
                <div class="col-md-3">
                    <label for="">Documento de rfc  <span class="is-invalid">*</span>  Tamaño máximo 5 MB</label>
                    
                    <input type="file" class="form-control" @change="onFileChangePDFRFC" accept="application/pdf" required/>
                    <label class="is-invalid">{{ validation.rfc_pdf }}</label>
                    <div v-if="fileURLrfc">
                    <h3>Vista previa del archivo:</h3>
                    <iframe :src="fileURLrfc" width="100%" height="400"></iframe>
                    </div>
                </div>
                
            </div>
           
        </div>-->
        <button type="button" v-if="existeInformacion == false" class="btn" style="background-color: #F49315; color: white;" @click="guardar">Guardar información de facturación</button>
        <button type="button" v-if="existeInformacion == true" class="btn btn-warning" @click="actualizar">Actualizar información de facturación</button>
    
        </template>
        <script>
        import axios from 'axios';
        import Swal from 'sweetalert2';
        export default {
            data() {
                return {
                    estados:[],
                    datosFormaPago:[],
                    datosMetodoPago:[],
                    cfdi_datos:[],
                    existeInformacion:false,
                    isButton1Disabled: false,
                    isButton2Disabled: true,
                    form:{
                        razon_social:'',
                        telefono:'',
                        email:'',
                        rfc:'',
                        cfdi:'',
                        forma_pago:'',
                        metodo_pago:'',
                        regimen_fiscal:'',
                        cp_domicilio_fiscal:'',
                        constancia_fiscal_pdf:'',
                        calle:'',
                        numero_exterior:'',
                        numero_interior:'',
                        colonia:'',
                        codigo_postal:'',
                        municipio:'',
                        estado:'',
                        rfc_pdf:'',
                        usuario:'',
                        idcotizacion:"",
                        id:""
                    },
                    validation:{
                       /* razon_social:"",
                        telefono:"",
                        email:"",*/

                        razon_social:"",
                        telefono:"",
                        email:"",
                        rfc:"",
                        cfdi:"",
                        forma_pago:"",
                        metodo_pago:"",
                        regimen_fiscal:"",
                        cp_domicilio_fiscal:"",
                        constancia_fiscal_pdf:"",
                        calle:"",
                        numero_exterior:"",
                        numero_interior:"",
                        colonia:"",
                        codigo_postal:"",
                        municipio:"",
                        estado:"",
                        rfc_pdf:""
                    },
                    existeInformacion:false,
                    loading:false,
                    file: null,
                    fileURL: null,
                    filerfc: null,
                    fileURLrfc: null,
                    isLoading:false

                }  
            },
            created() {
                this.consultar();
                this.formaPagoDatos();
                this.metodo_pagoDatos();
                this.cfdiDatos();
                this.obtenerEstados();
            },
            methods: {
                async obtenerEstados() {
                    try {
                        const response = await axios.get(this.$rutaServer+'estados');

                        this.estados = response.data.data;
                    } catch (error) {
                        console.error('Error al obtener los estados:', error);
                    }
                },
                onFileChangePDF(event) {
                    const file = event.target.files[0];
                    if (file && file.type === 'application/pdf') {
                        this.file = file;
                        this.fileURL = URL.createObjectURL(file);
                    } else {
                        alert('Por favor, seleccione un archivo PDF.');
                    }
                },
                onFileChangePDFRFC(event) {
                    const file = event.target.files[0];
                    if (file && file.type === 'application/pdf') {
                        this.filerfc = file;
                        this.fileURLrfc = URL.createObjectURL(file);
                    } else {
                        alert('Por favor, seleccione un archivo PDF.');
                    }
                },
                guardar() {
                    var idcotizacion = localStorage.getItem('idcotizacion');
                    var usuario = localStorage.getItem('email');
    
                    this.form.idcotizacion = idcotizacion;
                    this.form.usuario = usuario;
                    
    
                    const formData = new FormData();
               
                    formData.append('razon_social', this.form.razon_social);
                    formData.append('telefono', this.form.telefono); 
                    formData.append('email', this.form.email); 
                    formData.append('id', this.form.id); 
                    formData.append('rfc', this.form.rfc); 
                    formData.append('cfdi', this.form.cfdi); 
                    formData.append('usuario', usuario); 
    
    
                    formData.append('forma_pago', this.form.forma_pago);
                    formData.append('metodo_pago', this.form.metodo_pago); 
                    formData.append('regimen_fiscal', this.form.regimen_fiscal); 
                    formData.append('cp_domicilio_fiscal', this.form.cp_domicilio_fiscal); 
                    formData.append('idcotizacion', idcotizacion); 
                    formData.append('calle', this.form.calle); 
                    formData.append('numero_exterior', this.form.numero_exterior); 
                    formData.append('numero_interior', this.form.numero_interior); 
                    formData.append('colonia', this.form.colonia); 
                    formData.append('codigo_postal', this.form.codigo_postal); 
                    formData.append('municipio', this.form.municipio); 
                    formData.append('estado', this.form.estado); 
                    formData.append('rfc_pdf', this.form.rfc_pdf); 
    
    
    
                    
                    if(this.file){
                        formData.append('constancia_fiscal_pdf', this.file);
                    }
                    if(this.filerfc){
                        formData.append('rfc_pdf', this.filerfc);
                    }
                    axios.post(this.$rutaServer+'guardarRegistroConPDF', formData)
                    .then(response => {
                        if (response.status == 201) {
                            Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                            this.validation.razon_social = '';
                            this.validation.email = '';
                            this.validation.telefono = '';
                            this.validation.rfc = '';
                            this.validation.cfdi = '';
                            this.validation.forma_pago = '';
                            this.validation.metodo_pago = '';
                            this.validation.regimen_fiscal = '';
                            this.validation.cp_domicilio_fiscal = '';
                            this.validation.constancia_fiscal_pdf = '';
                            this.validation.calle = '';
                            this.validation.numero_exterior = '';
                            this.validation.numero_interior = '';
                            this.validation.colonia = '';
                            this.validation.codigo_postal = '';
                            this.validation.municipio = '';
                            this.validation.estado = '';
                            this.validation.rfc_pdf = '';
                            this.consultar();
                        }
                    })
                    .catch(error => {
                        Swal.fire('error!', 'Todos los campos son requeridos', 'error');
                        if(error.response.data.errors?.razon_social?.[0]){
                                    this.validation.razon_social = error.response.data.errors?.razon_social?.[0];
                                }
                                if(error.response.data.errors?.email?.[0]){
                                    this.validation.email = error.response.data.errors?.email?.[0];
                                }
                                if(error.response.data.errors?.telefono?.[0]){
                                    this.validation.telefono = error.response.data.errors?.telefono?.[0];
                                }
                        if(error.response.data.errors?.rfc?.[0]){
                            this.validation.rfc = error.response.data.errors?.rfc?.[0];
                        }
                        if(error.response.data.errors?.cfdi?.[0]){
                            this.validation.cfdi = error.response.data.errors?.cfdi?.[0];
                        }
                        if(error.response.data.errors?.forma_pago?.[0]){
                            this.validation.forma_pago = error.response.data.errors?.forma_pago?.[0];
                        }
                        if(error.response.data.errors?.metodo_pago?.[0]){
                            this.validation.metodo_pago = error.response.data.errors?.metodo_pago?.[0];
                        }
                        if(error.response.data.errors?.regimen_fiscal?.[0]){
                            this.validation.regimen_fiscal = error.response.data.errors?.regimen_fiscal?.[0];
                        }
                        if(error.response.data.errors?.cp_domicilio_fiscal?.[0]){
                            this.validation.cp_domicilio_fiscal = error.response.data.errors?.cp_domicilio_fiscal?.[0];
                        }
                        if(error.response.data.errors?.constancia_fiscal_pdf?.[0]){
                            this.validation.constancia_fiscal_pdf = error.response.data.errors?.constancia_fiscal_pdf?.[0];
                        }
                        if(error.response.data.errors?.calle?.[0]){
                            this.validation.calle = error.response.data.errors?.calle?.[0];
                        }
                        if(error.response.data.errors?.numero_exterior?.[0]){
                            this.validation.numero_exterior = error.response.data.errors?.numero_exterior?.[0];
                        }
                        if(error.response.data.errors?.numero_interior?.[0]){
                            this.validation.numero_interior = error.response.data.errors?.numero_interior?.[0];
                        }
                        if(error.response.data.errors?.colonia?.[0]){
                            this.validation.colonia = error.response.data.errors?.colonia?.[0];
                        }
                        if(error.response.data.errors?.codigo_postal?.[0]){
                            this.validation.codigo_postal = error.response.data.errors?.codigo_postal?.[0];
                        }
                        if(error.response.data.errors?.municipio?.[0]){
                            this.validation.municipio = error.response.data.errors?.municipio?.[0];
                        }
                        if(error.response.data.errors?.estado?.[0]){
                            this.validation.estado = error.response.data.errors?.estado?.[0];
                        }
                        if(error.response.data.errors?.rfc_pdf?.[0]){
                            this.validation.rfc_pdf = error.response.data.errors?.rfc_pdf?.[0];
                        }
                                
                    });
                },
                actualizar() {
                    var idcotizacion = localStorage.getItem('idcotizacion');
                    var usuario = localStorage.getItem('email');
    
                    this.form.idcotizacion = idcotizacion;
                    this.form.usuario = usuario;
                    
    
                    const formData = new FormData();
               
                    formData.append('razon_social', this.form.razon_social);
                    formData.append('telefono', this.form.telefono); 
                    formData.append('email', this.form.email); 
                    formData.append('id', this.form.id); 
                    formData.append('rfc', this.form.rfc); 
                    formData.append('cfdi', this.form.cfdi); 
                    formData.append('usuario', usuario); 
    
    
                    formData.append('forma_pago', this.form.forma_pago);
                    formData.append('metodo_pago', this.form.metodo_pago); 
                    formData.append('regimen_fiscal', this.form.regimen_fiscal); 
                    formData.append('cp_domicilio_fiscal', this.form.cp_domicilio_fiscal); 
                    formData.append('idcotizacion', idcotizacion); 
                    formData.append('calle', this.form.calle); 
                    formData.append('numero_exterior', this.form.numero_exterior); 
                    formData.append('numero_interior', this.form.numero_interior); 
                    formData.append('colonia', this.form.colonia); 
                    formData.append('codigo_postal', this.form.codigo_postal); 
                    formData.append('municipio', this.form.municipio); 
                    formData.append('estado', this.form.estado); 
                    //formData.append('rfc_pdf', this.form.rfc_pdf); 
    
    
    
                    
                    if(this.file){
                        formData.append('constancia_fiscal_pdf', this.file);
                    }
                    if(this.filerfc){
                        formData.append('rfc_pdf', this.filerfc);
                    }
                    axios.post(this.$rutaServer+'actualizarRegistroConPDF', formData)
                    .then(response => {
                        if (response.status == 200) {
                            Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                            this.validation.razon_social = '';
                            this.validation.email = '';
                            this.validation.telefono = '';
                            this.validation.rfc = '';
                            this.validation.cfdi = '';
                            this.validation.forma_pago = '';
                            this.validation.metodo_pago = '';
                            this.validation.regimen_fiscal = '';
                            this.validation.cp_domicilio_fiscal = '';
                            this.validation.constancia_fiscal_pdf = '';
                            this.validation.calle = '';
                            this.validation.numero_exterior = '';
                            this.validation.numero_interior = '';
                            this.validation.colonia = '';
                            this.validation.codigo_postal = '';
                            this.validation.municipio = '';
                            this.validation.estado = '';
                            this.validation.rfc_pdf = '';
                            this.consultar();
                        }
                    })
                    .catch(error => {
                        Swal.fire('error!', 'Todos los campos son requeridos', 'error');
                        if(error.response.data.errors?.razon_social?.[0]){
                                    this.validation.razon_social = error.response.data.errors?.razon_social?.[0];
                                }
                                if(error.response.data.errors?.email?.[0]){
                                    this.validation.email = error.response.data.errors?.email?.[0];
                                }
                                if(error.response.data.errors?.telefono?.[0]){
                                    this.validation.telefono = error.response.data.errors?.telefono?.[0];
                                }
                        if(error.response.data.errors?.rfc?.[0]){
                            this.validation.rfc = error.response.data.errors?.rfc?.[0];
                        }
                        if(error.response.data.errors?.cfdi?.[0]){
                            this.validation.cfdi = error.response.data.errors?.cfdi?.[0];
                        }
                        if(error.response.data.errors?.forma_pago?.[0]){
                            this.validation.forma_pago = error.response.data.errors?.forma_pago?.[0];
                        }
                        if(error.response.data.errors?.metodo_pago?.[0]){
                            this.validation.metodo_pago = error.response.data.errors?.metodo_pago?.[0];
                        }
                        if(error.response.data.errors?.regimen_fiscal?.[0]){
                            this.validation.regimen_fiscal = error.response.data.errors?.regimen_fiscal?.[0];
                        }
                        if(error.response.data.errors?.cp_domicilio_fiscal?.[0]){
                            this.validation.cp_domicilio_fiscal = error.response.data.errors?.cp_domicilio_fiscal?.[0];
                        }
                        if(error.response.data.errors?.constancia_fiscal_pdf?.[0]){
                            this.validation.constancia_fiscal_pdf = error.response.data.errors?.constancia_fiscal_pdf?.[0];
                        }
                        if(error.response.data.errors?.calle?.[0]){
                            this.validation.calle = error.response.data.errors?.calle?.[0];
                        }
                        if(error.response.data.errors?.numero_exterior?.[0]){
                            this.validation.numero_exterior = error.response.data.errors?.numero_exterior?.[0];
                        }
                        if(error.response.data.errors?.numero_interior?.[0]){
                            this.validation.numero_interior = error.response.data.errors?.numero_interior?.[0];
                        }
                        if(error.response.data.errors?.colonia?.[0]){
                            this.validation.colonia = error.response.data.errors?.colonia?.[0];
                        }
                        if(error.response.data.errors?.codigo_postal?.[0]){
                            this.validation.codigo_postal = error.response.data.errors?.codigo_postal?.[0];
                        }
                        if(error.response.data.errors?.municipio?.[0]){
                            this.validation.municipio = error.response.data.errors?.municipio?.[0];
                        }
                        if(error.response.data.errors?.estado?.[0]){
                            this.validation.estado = error.response.data.errors?.estado?.[0];
                        }
                        if(error.response.data.errors?.rfc_pdf?.[0]){
                            this.validation.rfc_pdf = error.response.data.errors?.rfc_pdf?.[0];
                        }
                    });
                },
                consultar(){
                    this.isLoading = true;
                    var idcotizacion = localStorage.getItem('idcotizacion');
                    
                    axios.post(this.$rutaServer+'consultarFacturacion',{idcotizacion:idcotizacion} )
                    .then(response => {
                        if (response.status == 200) {
                            this.isLoading = false;
                            if(response.data.length > 0){
                                this.existeInformacion = true;
                            }
                            
                                
                                    this.form.razon_social = response.data[0].razon_social;
                                    this.form.telefono = response.data[0].telefono;
                                    this.form.email = response.data[0].email;
                                    this.form.id = response.data[0].id;
                                    this.form.rfc = response.data[0].rfc;
                                    this.form.cfdi = response.data[0].cfdi;
                                    this.form.forma_pago = response.data[0].forma_pago;
                                    this.form.metodo_pago = response.data[0].metodo_pago;
                                    this.form.regimen_fiscal = response.data[0].regimen_fiscal;
                                    this.form.cp_domicilio_fiscal = response.data[0].cp_domicilio_fiscal;
                                    this.form.constancia_fiscal_pdf = response.data[0].constancia_fiscal_pdf;
                                    this.form.calle = response.data[0].calle;
                                    this.form.numero_exterior = response.data[0].numero_exterior;
                                    this.form.numero_interior = response.data[0].numero_interior;
                                    this.form.colonia = response.data[0].colonia;
                                    this.form.codigo_postal = response.data[0].codigo_postal;
                                    this.form.municipio = response.data[0].municipio;
                                    this.form.estado = response.data[0].estado;
                                    this.form.rfc_pdf = response.data[0].rfc_pdf;
                                    
    
                                    if(response.data[0].constancia_fiscal_pdf){
                                        this.fileURL = this.$rutaImagenes+response.data[0].constancia_fiscal_pdf;
                                       // this.file = 1;
                                    }
                                    if(response.data[0].rfc_pdf){
                                        this.fileURLrfc = this.$rutaImagenes+response.data[0].rfc_pdf;
                                        //this.fileURLrfc = 1;
                                    }
                                
                           
                            
    
    
                            
    
                        }
                    })
                    .catch(error => {
                        
                    });
                },
                formaPagoDatos(){
                    axios.get(this.$rutaServer+'formaPago')
                    .then(response => {
                        if (response.status == 200) {
                            this.datosFormaPago = response.data;
                        }
                    })
                    .catch(error => {
                        
                    });
                },
                metodo_pagoDatos(){
                    axios.get(this.$rutaServer+'metodo_pago')
                    .then(response => {
                        console.log(response);
                         console.log(this.$rutaServer);
                        if (response.status == 200) {
                            this.datosMetodoPago = response.data;
                        }
                    })
                    .catch(error => {
                        
                    });
                },
                cfdiDatos(){
                    axios.get(this.$rutaServer+'cfdi')
                    .then(response => {
                       // console.log(response);
                        if (response.status == 200) {

                            this.cfdi_datos = response.data;
                        }
                    })
                    .catch(error => {
                        
                    });
                }

            },
                
        };
        </script>